module.exports = __webpack_public_path__ + "img/new-year-light-medium.ecfa8b6b.svg";